'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _CompanyBlock = require('./CompanyBlock/CompanyBlock');var _CompanyBlock2 = _interopRequireDefault(_CompanyBlock);
var _helpers = require('./helpers');var _helpers2 = _interopRequireDefault(_helpers);
var _formatObjectToQuery = require('../../utils/formatObjectToQuery');var _formatObjectToQuery2 = _interopRequireDefault(_formatObjectToQuery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CompanyInPropertiesList = function CompanyInPropertiesList(_ref) {var company = _ref.company,isMobile = _ref.isMobile,translate = _ref.translate,locale = _ref.locale,routeData = _ref.routeData,isRtl = _ref.isRtl;
  var formatObject = (0, _formatObjectToQuery2.default)(routeData);
  var neighborhood = (0, _get2.default)(routeData, 'locationSearch.en.neighborhood');
  var city = (0, _get2.default)(routeData, 'locationSearch.en.city_name');

  var neighborhoodAgent = (0, _helpers2.default)(
  company.assigned_neighborhoods,
  city || formatObject.city,
  neighborhood || formatObject.neighborhood,
  'agent_catalog');


  return !!neighborhoodAgent ?

  _react2.default.createElement(_CompanyBlock2.default, {
    key: neighborhoodAgent.name,
    company: company,
    translate: translate,
    image: neighborhoodAgent.image,
    phoneNumber: neighborhoodAgent.phone_number,
    name: neighborhoodAgent.name,
    locale: locale,
    isMobile: isMobile,
    isRtl: isRtl }) :



  _react2.default.createElement(_CompanyBlock2.default, {
    company: company,
    translate: translate,
    locale: locale,
    isMobile: isMobile,
    isRtl: isRtl });


};

CompanyInPropertiesList.propTypes = {
  company: _propTypes2.default.shape({
    assigned_neighborhoods: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      agent_catalog: _propTypes2.default.shape({
        image: _propTypes2.default.string,
        name: _propTypes2.default.string,
        phone_number: _propTypes2.default.string,
        email: _propTypes2.default.string }) })),


    image: _propTypes2.default.string,
    id: _propTypes2.default.string,
    name: _propTypes2.default.object,
    phone_number: _propTypes2.default.string }),

  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool };exports.default =


CompanyInPropertiesList;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyInPropertiesList/CompanyInPropertiesList.js
// module id = 2636
// module chunks = 0